import React, {useCallback, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import {statusesYesOrNo} from "../../../../../data/StatusesYesOrNo";
import {materialReserveState} from "../../../../../data/MaterialReserveState";
import {materialEstimateUnitStates} from "../../../../../data/MaterialEstimateUnitState";
import {Paper} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import ButtonSelectAction from "../../../button/ButtonSelectAction";
import {ModalSelectAction} from "../../../modal/ModalSelectAction";
import MaterialReserveService from "../../../../../API/orders/reservation/MaterialReserveService";
import selectionTableUtil, {normalizeSelection} from "../../../../../utils/common/SelectionTableUtil";
import {EditLocalStoragePagesData} from "../../../../../utils/EditLocalStoragePagesData";
import {useLocation} from "react-router-dom";

const ReservationTableCuttingItem = ({
                                         data,
                                         setData,
                                         isColumnOrder,
                                         pageSize,
                                         isCalculation,
                                         enableRowSelection,
                                         handleModalAlert,
                                         showRowNumber = false,
                                     }) => {
    const [rowSelection, setRowSelection] = useState([]);
    const [openSelection, setOpenSelection] = useState(false)

    const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection)
    const currentSelection = normalizeSelection(rowSelection)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const pathname = useLocation().pathname
    const profile = JSON.parse(localStorage.getItem("profile"))
    const isSettingsRole = !!profile?.userRoles?.find(el => el.name === "ROLE_ORGANIZATION_USER_SETTINGS")

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }

    const modalActions = [
        {name: "Отправить на закупку", type: "setPurchase"},
    ]

    const handleSetPurchase = () => {
        MaterialReserveService.setPurchaseByIds(rowSelection)
            .then(function () {
                setData(prev => prev.map(el => rowSelection.includes(el.id) ? {
                    ...el,
                    materialReserveState: "PURCHASE"
                } : el))
                setOpenSelection(false)
                setRowSelection([])
                handleModalAlert("Отправлено на закупку", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }

    const handleDeleteReserve = useCallback(
        (row) => {
            MaterialReserveService.delete(row.id)
                .then(function () {
                    setData((prev) => prev.filter((el) => el.id !== row.id))
                    handleModalAlert("Резерв удалён", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        },
        [setData, handleModalAlert],
    );

    const menuItem = [
        {type: "delete", text: "Удалить резерв", handler: handleDeleteReserve},
    ]

    const columns = useMemo(() => {
        const baseColumns = [];

        if (showRowNumber) {
            baseColumns.push({
                id: 'rowNumber',
                header: '№',
                minSize: 10,
                maxSize: 10,
                enableSorting: false,
                enableColumnFilter: false,
                enableGrouping: false,
                Cell: ({row, table}) => {
                    const {pageIndex, pageSize: paginationPageSize} = table.getState().pagination;
                    return pageIndex * paginationPageSize + row.index + 1;
                },
            });
        }

        baseColumns.push(
            {
                id: 'length',
                header: 'Ширина',
                accessorKey: 'length',
                minSize: 15,
                maxSize: 15,
            },
            {
                id: 'width',
                header: 'Высота',
                accessorKey: 'width',
                minSize: 15,
                maxSize: 15,
            },
            {
                id: 'quantity',
                header: 'Кол.',
                accessorKey: 'quantity',
                minSize: 15,
                maxSize: 15,
                aggregationFn: 'sum',
                AggregatedCell: ({cell, table}) => (
                    <>
                        <Box sx={{
                            color: 'primary.main',
                            fontWeight: 'bold'
                        }}>
                            {cell.getValue()?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })}
                        </Box>
                    </>
                ),
            },
            {
                id: 'availabilityQuantity',
                header: 'Наличие',
                accessorKey: 'availabilityQuantity',
                minSize: 15,
                maxSize: 15,
                aggregationFn: 'sum',
                AggregatedCell: ({cell, table}) => (
                    <>
                        <Box sx={{
                            color: 'success.main',
                            fontWeight: 'bold'
                        }}>
                            {cell.getValue()?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })}
                        </Box>
                    </>
                ),

            },
            {
                id: 'materialReserveState',
                header: 'Статус',
                accessorKey: 'materialReserveState',
                minSize: 55,
                maxSize: 55,
                Cell: ({cell}) => materialReserveState[cell.getValue()],
                filterFn: (row, id, filterValue) => {
                    return materialReserveState[row.original.materialReserveState].toLowerCase().includes(filterValue.toLowerCase())
                },
            },
            {
                id: 'noteMaterialWarehouse',
                header: 'Ячейка',
                accessorKey: 'noteMaterialWarehouse',
                minSize: 15,
                maxSize: 100,
                Cell: ({cell}) => cell.getValue() == null ? '' : cell.getValue(),
            },
            {
                header: 'id',
                id: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
            },
        );

        const columnOffset = showRowNumber ? 1 : 0;

        if (!(isCalculation === true)) {
            baseColumns.splice(3 + columnOffset, 0, {
                id: 'temp',
                header: 'Закупка',
                accessorKey: 'temp',
                minSize: 15,
                maxSize: 15,
                Cell: ({cell}) => statusesYesOrNo[cell.getValue()],
            });
        }

        if (!(isCalculation === true)) {
            baseColumns.splice(5 + columnOffset, 0, {
                id: 'needToOrderQuantity',
                header: 'Необходимо заказать',
                accessorKey: 'needToOrderQuantity',
                minSize: 15,
                maxSize: 15,
                aggregationFn: 'sum',
                AggregatedCell: ({cell, table}) => (
                    <>
                        <Box sx={{
                            color: 'error.light',
                            fontWeight: 'bold'
                        }}>
                            {cell.getValue()?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })}
                        </Box>
                    </>
                ),
            });
        }

        if (!(isCalculation === true)) {
            baseColumns.splice(6 + columnOffset, 0, {
                id: 'orderedQuantity',
                header: 'Заказано',
                accessorKey: 'orderedQuantity',
                minSize: 15,
                maxSize: 15,
                aggregationFn: 'sum',
                AggregatedCell: ({cell, table}) => (
                    <>
                        <Box sx={{
                            color: 'secondary.main',
                            fontWeight: 'bold'
                        }}>
                            {cell.getValue()?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })}
                        </Box>
                    </>
                ),
            });
        }

        return baseColumns;

    }, [isCalculation, isColumnOrder, showRowNumber]);

    return (
        <div>
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}

                selectAllMode={"all"}
                positionActionsColumn="first"
                muiTableBodyCellProps={({cell}) => ({
                    sx: {
                        m: '0px 0px 0px 0px',
                        border: "none",
                        borderBottom: '1px solid #EAEBEA',
                        "&:after": {
                            display: "none",
                        },
                        "&:not(:last-of-type)": {
                            borderRight: '1px solid #EAEBEA',
                        },
                        ...(cell.column.id === 'mrt-row-actions' ? {
                            padding: 0,
                            width: "50px",
                            minWidth: "50px",
                            maxWidth: "50px",
                            boxSizing: "border-box",
                            textAlign: "center",
                            verticalAlign: "middle",
                            color: (theme) => theme.palette.text.light,
                            "& .MuiButtonBase-root": {
                                borderRadius: "4px",
                                width: "24px",
                                height: "24px",
                                opacity: 1,
                                margin: 0,
                                padding: 0,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                }
                            }
                        } : {}),
                    },
                })}
                muiTableHeadCellProps={({column}) => ({
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: column.id === 'mrt-row-actions' ? 0 : "10px",
                        paddingBottom: "0.2rem",
                        paddingTop: "0.2rem",
                        ...(column.id === 'mrt-row-actions' ? {
                            width: "50px",
                            minWidth: "50px",
                            maxWidth: "50px",
                            boxSizing: "border-box",
                            "& .Mui-TableHeadCell-Content-Wrapper": {
                                minWidth: "unset",
                                width: "100%",
                            },
                        } : {}),
                        ...(column.id === 'mrt-row-select' ? {
                            "& .Mui-TableHeadCell-Content-Wrapper": {
                                minWidth: "100%",
                            },
                        } : {}),
                    },
                })}
                muiTableBodyRowProps ={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}
                onRowSelectionChange={onRowSelectionChange}
                getRowId={(originalRow) => originalRow.id}
                enableRowSelection={enableRowSelection}
                state={{rowSelection: currentSelection, showGlobalFilter: true, pagination: tableOptions,}}
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 50,
                        minSize: 50,
                        maxSize: 50,
                        grow: false,
                    },
                    'mrt-row-select': {
                        size: "50px",
                        grow: false,
                    },
                }}
                columns={columns}
                data={data}
                rowHeight={13}
                columnSpacing={1}
                initialState={{
                    columnVisibility: {
                        id: false,
                    },
                    isFullScreen: false,
                    density: "compact",
                    pagination: {pageIndex: 0, pageSize: pageSize},
                }}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                enablePagination={false}
                enableTopToolbar={false}
                enableRowActions={true}
                renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => (
                    <MenuItem
                        key={el.type}
                        disabled={!isSettingsRole}
                        onClick={() => {
                            if (!isSettingsRole) {
                                return;
                            }
                            el.handler(row.original)
                            closeMenu();
                        }}
                        sx={{
                            margin: "0 8px",
                            borderRadius: "4px",
                            "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                        }}
                    >
                        {el.text}
                    </MenuItem>
                ))}
                enableTableFooter={false}
                enableBottomToolbar={false}
                enableStickyFooter={false}
                enableToolbarInternalActions={false}
                localization={MRT_Localization_RU}
            />
            {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: '100%',
                height: "88px",
                display: 'flex',
                justifyContent: "center",
                alignItems: 'center',
                backgroundColor: (theme) => theme.palette.primary.lightGrey,
            }} component="footer">
                <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpenSelection(true)}/>
            </Paper>}
            <ModalSelectAction
                open={openSelection}
                reset={() => setOpenSelection(false)}
                submit={handleSetPurchase}
                modalActions={modalActions}
            />
        </div>
    );
};

export default ReservationTableCuttingItem;